import { useState } from "react";
import { format, parse } from "date-fns";
import { id as idLoc } from "date-fns/locale";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { CalendarIcon } from "lucide-react";

export function DatePicker({ value, onChange, placeholder = "Pilih tanggal", testId, className = "" }) {
  const [open, setOpen] = useState(false);
  const date = value ? parse(value, "yyyy-MM-dd", new Date()) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" data-testid={testId} className={`justify-start gap-2 rounded-xl bg-white/60 dark:bg-[#202620] dark:border-white/10 dark:hover:bg-white/5 font-normal ${!value ? "text-slate-400 dark:text-slate-500" : "text-emerald-950 dark:text-emerald-50"} ${className}`}>
          <CalendarIcon className="h-4 w-4 text-emerald-600" />{value ? format(date, "d MMM yyyy", { locale: idLoc }) : placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 dark:bg-[#202620] dark:border-white/10" align="start">
        <Calendar mode="single" selected={date} locale={idLoc} onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }} initialFocus />
        {value && <div className="p-2 border-t border-slate-100 dark:border-white/10"><Button variant="ghost" size="sm" className="w-full" data-testid={`${testId}-clear`} onClick={() => { onChange(""); setOpen(false); }}>Hapus tanggal</Button></div>}
      </PopoverContent>
    </Popover>
  );
}
